import type { FinancialAdvisorsProductCardEntityType } from '@ria-client/supergraph/structuredContent/hydration/FinancialAdvisorsProductCard/types';
import { RatingTooltip, StarRating } from '@ria-client/tw-shared-ui';
import { ContentLink } from '../lib/content-link';
import { CardCta } from './card-cta';

export interface LenderDetailsProps {
  marketplaceEntity: FinancialAdvisorsProductCardEntityType;
  monetizingCtaLabel?: string;
  starRatingTooltip: string;
  displayAdLabel?: boolean;
}

export function LenderDetails({
  marketplaceEntity,
  monetizingCtaLabel,
  starRatingTooltip,
  displayAdLabel,
}: LenderDetailsProps) {
  const rating = marketplaceEntity.starRating ? (
    <>
      <StarRating gap="6px" size="19px" value={marketplaceEntity.starRating} />
      <div className="mt-2">
        <span className="typography-text-bold mr-2">{marketplaceEntity.starRating.toFixed(1)}</span>
        <span className="typography-text whitespace-nowrap">
          <ContentLink href={marketplaceEntity.reviewLink} rel="nofollow" target="_blank">
            NerdWallet rating
          </ContentLink>{' '}
          <RatingTooltip starRatingTooltip={starRatingTooltip} />
        </span>
      </div>
    </>
  ) : (
    'Not yet rated'
  );

  const dates =
    marketplaceEntity.isRiaOffer &&
    marketplaceEntity.reviewedAtDate &&
    marketplaceEntity.periodConsideredDate ? (
      <div className="typography-text-small mt-3 flex flex-col text-center italic text-muted-foreground">
        <span>{marketplaceEntity.reviewedAtDate}</span>
        <span>{marketplaceEntity.periodConsideredDate}</span>
      </div>
    ) : null;

  return (
    <div className="flex flex-col items-center gap-4">
      <img
        alt={`${marketplaceEntity.displayName} logo`}
        className="aspect-[208/96] w-full max-w-[208px] object-contain"
        src={marketplaceEntity.image.source}
      />
      <div className="flex flex-col items-center gap-3">
        <span className="typography-text-small text-center">{marketplaceEntity.displayName}</span>
        <div className="hidden flex-col items-center sm:flex">
          {rating}
          {dates}
        </div>
        <div className="flex flex-col items-center sm:hidden">{rating}</div>
      </div>
      <div className="flex w-full flex-col gap-2">
        <CardCta
          displayAdLabel={displayAdLabel}
          marketplaceEntity={marketplaceEntity}
          monetizingCtaLabel={monetizingCtaLabel}
        />
      </div>
    </div>
  );
}
